/**
 * @file: QuotationItemType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum QuotationItemType {
  Construction = 'construction',
  Material = 'material',
}

export const QuotationItemTypeValueSet = new Set([
  QuotationItemType.Construction,
  QuotationItemType.Material,
]);
